export default {"src":"/_next/static/media/adaptive-security-measures.1c50a777.svg","height":615,"width":588,"blurWidth":0,"blurHeight":0};